import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=e1b80d3a&scoped=true&"
import script from "./Books.vue?vue&type=script&lang=ts&"
export * from "./Books.vue?vue&type=script&lang=ts&"
import style0 from "./Books.vue?vue&type=style&index=0&id=e1b80d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b80d3a",
  null
  
)

export default component.exports